import { AddAppsUpsell } from "@mirage/growth/onboarding/add-apps-upsell/AddAppsUpsell";
import { ExtensionUpsellBanner } from "@mirage/growth/onboarding/extension-upsell/ExtensionUpsellBanner";
import { useAddAppsUpsellInEmbeddedChat } from "@mirage/mosaics/ComposeAssistant/onboarding/useAddAppsUpsellInEmbeddedChat";
import { useExtensionUpsellInChat } from "@mirage/mosaics/ComposeAssistant/onboarding/useExtensionUpsellInChat";
import { openURL } from "@mirage/service-platform-actions";

import { useGetDeepLinkUrl } from "@mirage/service-auth/useGetDeepLinkUrl";
import { RouteToSlug } from "@mirage/shared/fss-bridge/bridgeRouting";
import { useEffect, useMemo, useRef } from "react";

export const EmbeddedUpsells = () => {
  const upsellToShowRef = useRef<"extension" | "add-apps" | null>(null);

  const {
    extensionInfo,
    onDismiss: onDismissExtensionUpsell,
    isLoading: isExtensionUpsellLoading,
  } = useExtensionUpsellInChat();

  const memoizedAddAppsParams = useMemo(
    () => ({
      showAddAppsModal: "true",
    }),
    [],
  );
  const getAddAppsUrl = useGetDeepLinkUrl(
    RouteToSlug.HOME,
    memoizedAddAppsParams,
  );

  const {
    showAddAppsUpsell,
    onDismiss: onDismissAddAppsUpsell,
    isLoading: isAddAppsUpsellLoading,
  } = useAddAppsUpsellInEmbeddedChat();

  const openAddApps = () => {
    openURL(getAddAppsUrl());
    onDismissAddAppsUpsell();
  };

  const isLoading = isExtensionUpsellLoading || isAddAppsUpsellLoading;
  useEffect(() => {
    if (!isLoading && upsellToShowRef.current === null) {
      if (extensionInfo) {
        upsellToShowRef.current = "extension";
      } else if (showAddAppsUpsell) {
        upsellToShowRef.current = "add-apps";
      }
    }
  }, [extensionInfo, showAddAppsUpsell, isLoading]);

  // Extension upsell takes precedence over add apps upsell.
  if (upsellToShowRef.current === "extension" && extensionInfo) {
    return (
      <ExtensionUpsellBanner
        extensionInfo={extensionInfo}
        onDismiss={onDismissExtensionUpsell}
        isEmbedded={true}
      />
    );
  }

  if (upsellToShowRef.current === "add-apps" && showAddAppsUpsell) {
    return (
      <AddAppsUpsell
        onDismiss={onDismissAddAppsUpsell}
        onOpenAddApps={openAddApps}
        isEmbedded={true}
        actionSurface="chat"
      />
    );
  }

  return null;
};
